<template>
  <div>
    <div class="bg-gray-900 py-1 rounded-t-none rounded-lg">
      <div class="px-3 py-2">Sélectionner</div>
      <div class="flex justify-between pt-2 pb-4">
        <div @click="restorelastSelect()" class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-2">
            <img
              v-if="selected.length === lastSelected.length"
              class="w-8 h-8 cursor-pointer"
              src="../../assets/icons/selectedOn.svg"
              alt="Dernière sélection"
            />
            <img
              v-else
              class="w-8 h-8 cursor-pointer"
              src="../../assets/icons/selectedOff.svg"
              alt="Dernière sélection"
            />
          </div>
          <div :class="[selected.length === lastSelected.length ? 'text-white' : 'text-gray-600']">
            {{ lastSelected.length }}
          </div>
        </div>
        <div @click="selectAllForLabel(label)" class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-2">
            <img class="w-8 h-8 cursor-pointer" src="../../assets/icons/selectAll.svg" alt="Tout sélectionner" />
          </div>
          <div :class="[selected.length === getAnswersCountForLabel(label) ? 'text-white' : 'text-gray-600']">
            Tout
          </div>
        </div>
        <div @click="removeSelected()" class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-2">
            <img class="w-8 h-8 cursor-pointer" src="../../assets/icons/deselectAll.svg" alt="Dé-sélectionner tout" />
          </div>
          <div :class="[!selected.length ? 'text-white' : 'text-gray-600']">
            Rien
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex"

export default {
  props: {
    label: Object,
  },
  computed: {
    ...mapState({
      deselect: (state) => state.grid.deselect,
      selected: (state) => state.answers.selected,
      lastSelected: (state) => state.answers.lastSelected,
      answersCount: (state) => state.answers.all.length,
    }),
    ...mapGetters("answers", ["getAnswersCountForLabel", "getSelectedAnswersCountForLabel"]),
  },
  methods: {
    ...mapMutations("grid", ["toggleDeselect"]),
    ...mapMutations("answers", ["restorelastSelect", "selectAllForLabel", "removeSelected"]),
  },
}
</script>

<style></style>
